import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLegalLinks } from '../lib/legalLinks';

// post-t7-2b (A1, #613): el aviso de las TRES puertas de unirse a un grupo (la pagina de la liga, la tarjeta de
// Ajustes y la ventana "Te esta esperando tu grupo"). Dos llaves, enteras: la frase ratificada y la liga, que va al
// final como oracion aparte. La liga lleva al aviso del idioma de la pagina por `getLegalLinks` (en la app, el sitio
// de produccion) y se abre como la casa abre sus ligas legales (LegalAcceptance): pestana nueva, sin opener.
// Sin `Trans` a proposito: los dobles de `react-i18next` de las suites de las tres puertas no lo traen.
// dashboard-rediseno, segunda vuelta (D13): la liga mide 44 de toque sin mover el renglon (la tecnica
// de la casa: relleno arriba y abajo y el mismo margen en negativo).
export default function AvisoAlUnirse({ className = '' }) {
  const { t, i18n } = useTranslation(['dashboard']);
  const ligas = getLegalLinks(i18n?.language);
  return (
    <p className={`text-xs text-[#a0a0a0] leading-relaxed ${className}`.trim()} data-testid="aviso-unirse">
      {t('dashboard:groups.leg_join')}{' '}
      <a
        href={ligas.privacy}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block py-[14px] -my-[14px] underline underline-offset-2 hover:text-[#FF6B00] transition-colors"
        data-testid="aviso-unirse-liga">
        {t('dashboard:groups.leg_join_liga')}
      </a>
    </p>
  );
}
